<template>
  <div class="subPage live-calendar">
    <div class="panel">
      <div class="panel-body">
        <div class="calendar-wrap">
          <el-calendar v-model="dateValue">
            <template slot="dateCell" slot-scope="{ data }">
              <span>{{ data.day.split("-").slice(2).join("-") }}</span>
              <template v-if="calendarList.length">
                <div class="isTag" v-if="showTag(data.day)"></div>
              </template>
            </template>
          </el-calendar>
        </div>
        <div class="live-info">
          <div class="live-info--title">直播信息</div>
          <div class="live-info--wrap">
            <template v-if="currentList.length">
              <div class="live-info--item-wrap">
                <div class="live-info--item" v-for="(item, index) in currentList" :key="index">
                  <div class="live-btn--info">
                    <img :src="index === itemActive ? playCurImg : playImg" />
                    <div class="info-time">
                      <div class="date">{{ item.date }}</div>
                      <div class="time">{{ item.time }}</div>
                    </div>
                  </div>
                  <div class="live-info--cont">
                    <div class="info-img">
                      <el-image class="image" :src="item.cover" @error="handleError" />
                    </div>
                    <div class="info-text">
                      <div class="title multiple-ellipsis">{{ item.title }}</div>
                      <div class="btn">
                        <el-button class="btn" type="primary" round size="small"
                          @click="toDetail(item, index)">详情</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <el-empty :image-size="80"></el-empty>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 引用方法 */
import dayjs from "dayjs"
import { getRecentLiveList } from "@/api/live.js"
export default {
  name: "LivePreviewList",
  components: {},
  data() {
    return {
      goodsimage: require("@/assets/default/image02.jpg"),
      dateValue: new Date(),
      playImg: require("@/assets/home/play_2.png"),
      playCurImg: require("@/assets/home/play_3.png"),
      itemActive: null,
      currentList: [],
      calendarList: [], // 日历
      lastMonthday: "", //切换月份的总天数
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
  },
  computed: {},
  watch: {
    dateValue: {
      handler(newVal) {
        if (newVal === "") return false
        this.initRecentList('switch')
      },
      immediate: true,
      deep: true
    },
  },
  created() {
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 获取列表数据
    initData() {
      this.$nextTick(() => {
        //给上月、今天、下月添加点击事件
        // 点击前一个月
        let prevBtn = document.querySelector(
          ".el-calendar__button-group .el-button-group>button:nth-child(1)"
        )
        prevBtn.addEventListener("click", () => {
          this.switchDate(this.dateValue)
        })
        let dayBtn = document.querySelector(
          ".el-calendar__button-group .el-button-group>button:nth-child(2)"
        )
        dayBtn.addEventListener("click", () => {
          this.switchDate(this.dateValue)
        })
        let nextBtn = document.querySelector(
          ".el-calendar__button-group .el-button-group>button:nth-child(3)"
        )
        nextBtn.addEventListener("click", () => {
          this.switchDate(this.dateValue)
        })
      })
      this.switchDate(new Date())
    },
    initRecentList(str) {
      if (str === 'opCalendar') { //当月的直播记录查询
        let resDate = parseInt(this.timeFormat(1).replaceAll('.', ''))
        let start_time = parseInt(resDate.toString().substring(0, 6) + '01')
        let end_time = parseInt(resDate.toString().substring(0, 6) + this.lastMonthday.toString())
        let params = {
          start_date: start_time,
          end_date: end_time
        }
        getRecentLiveList(params).then(res => {
          this.calendarList = []
          if (res.code === 0) {
            res.data.forEach(item => {
              this.calendarList.push({
                date: item.date,
                list: item.list || []
              })
            })
          }
        })
      } else if (str === 'switch') {
        this.currentList = []
        let start_time = parseInt(this.timeFormat(1).replaceAll('.', ''))
        let end_time = start_time
        let params = {
          start_date: start_time,
          end_date: end_time
        }
        getRecentLiveList(params).then(res => {
          if (res.code === 0) {
            if (res.data[0]?.list && res.data[0]?.list.length) {
              res.data[0].list.map(item => {
                let time = dayjs.unix(item.start_time).format("YYYY/MM/DD HH:mm:ss").split(' ')
                let r_date = time[0].split('/')
                item.date = r_date[1] + '/' + r_date[2]
                item.time = time[1]
              })
              this.currentList = res.data[0].list || []
            }
          }
        })
      }
    },
    showTag(value) { //遍历日历，有直播记录的打标记
      let arr = this.calendarList
      for (let i = 0; i < arr.length; i++) {
        let ele = arr[i]
        let resStr = value.replaceAll('-', '.')
        if (ele.date === resStr && ele.list.length) {
          return true
        }
      }
    },
    switchDate(dateVal) { //切换月份的总天数
      let date = this.formatDate(dateVal)
      let tempDate = new Date(date[0], date[1], 0)
      this.lastMonthday = tempDate.getDate()
      this.initRecentList('opCalendar')
    },
    formatDate(date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      return [y, m, d]
    },
    timeFormat(data) { //补齐时间，返回格式为:yyyy.mm.dd
      let date = ''
      if (!data) {
        date = new Date()
      } else {
        date = this.dateValue
      }
      let strArr = this.formatDate(date)
      let timer = ''
      strArr.forEach((item, index) => {
        if (!index) {
          timer = item
        } else {
          if (parseInt(item) < 10) {
            item = '.0' + item
          } else {
            item = '.' + item
          }
          timer = timer + item
        }
      })
      return timer
    },
    getNextDate(day = 1, format = "{y}-{m}-{d}") { //当前日期后4天
      const nDate = new Date()
      nDate.setDate(nDate.getDate() + day)
      const formatObj = {
        y: nDate.getFullYear(),
        m: nDate.getMonth() + 1,
        d: nDate.getDate(),
      }
      return format.replace(/{([ymd])+}/g, (result, key) => {
        const value = formatObj[key]
        return value.toString().padStart(2, "0")
      })
    },
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    toDetail(item, inx) {
      this.itemActive = inx
      window.localStorage.setItem("menuId", 4)
      this.$store.dispatch("setmenuid", 4)
      this.$router.push({
        path: "/move",
        query: {
          sn: item.sn,
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.subPage {
  min-height: 400px;
  width: 100%;

  .panel {
    width: 100%;
    background-color: #fff;

    .panel-head {
      padding: 20px;
      background-color: #e5eef8;
      border-radius: 5px 5px 0px 0px;

      .panel-title {
        color: #000;
        font-size: 24px;
        font-weight: bold;
        line-height: 40px;
      }
    }

    .panel-body {
      min-height: 100px;
      padding: 20px 20px 0px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .live-info {
        width: calc(100% - 580px);
        margin-left: 20px;
        box-sizing: border-box;

        .live-info--title {
          color: #333;
          font-size: 16px;
          height: 40px;
          line-height: 40px;
          padding: 10px 20px;
        }

        .live-info--wrap {
          width: 100%;
          height: 580px;
          box-sizing: border-box;
          overflow-y: auto;
          padding-left: 20px;

          .live-info--item-wrap {
            border-left: 1px solid #dcdfe6;
            min-width: 560px;
            min-height: 580px;

            .live-info--item {
              display: flex;
              padding: 20px 0px;
              box-sizing: border-box;
              transform: translateX(-10px);
            }

            .live-btn--info {
              flex: 1;
              max-width: 140px;
              display: flex;
              align-items: center;

              img {
                width: 20px;
                height: 24px;
              }

              .info-time {
                font-weight: 500;
                font-size: 14px;
                color: #999999;
                height: 56px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .date {
                  font-size: 24px;
                  color: #333333;
                }
              }
            }

            .live-info--cont {
              flex: 1;
              display: flex;
              align-items: center;

              .info-img {
                width: 260px;
                height: 145px;
                border-radius: 5px;
                overflow: hidden;
                object-fit: contain;

                .image {
                  height: 100%;
                  width: 100%;
                  display: inline-block;
                  -webkit-transition-duration: 0.3s;
                  transition-duration: 0.3s;
                  -webkit-transition-property: transform;
                  transition-property: transform;
                  -webkit-transform: translateZ(0);
                  transform: translateZ(0);
                  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
                }

                .image:hover,
                .image:focus,
                .image:active {
                  -webkit-transform: scale(1.1);
                  transform: scale(1.1);
                }

                .image {
                  width: 100%;
                  height: 100%;
                }
              }

              .info-text {
                flex: 1;
                max-width: calc(100% - 260px);
                height: 100%;
                padding-left: 20px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                  font-weight: bold;
                  font-size: 18px;
                  color: #333333;
                }

                .btn {
                  button {
                    width: 92px;
                  }
                }
              }
            }
          }
        }
      }

      .calendar-wrap {
        flex: 1;
        max-width: 580px;
        border-right: 1px solid rgba($color: #eeeeee, $alpha: 0.5);

        ::v-deep .el-calendar__header {
          border: none;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .live-calendar {
    box-sizing: border-box;
    padding: 0 10px;

    .panel {
      .panel-head {
        padding: 10px 15px;

        .panel-title {
          font-size: 16px;
          line-height: 24px;
        }
      }

      .panel-body {
        display: block;
        flex-direction: column;
        padding: 10px;

        .calendar-wrap {
          width: 100%;
          max-width: 100%;
          border-right: none;
          border-bottom: 1px solid #eee;
          margin-bottom: 15px;
          padding-bottom: 15px;

          ::v-deep .el-calendar {
            font-size: 12px;
          }
        }

        .live-info {
          width: 100%;
          margin-left: 0;

          .live-info--title {
            font-size: 14px;
            height: 30px;
            line-height: 30px;
            padding: 5px 10px;
          }

          .live-info--wrap {
            height: auto;
            max-height: 400px;
            padding-left: 10px;

            .live-info--item-wrap {
              min-width: auto;
              min-height: auto;
              padding-left: 10px;

              .live-info--item {
                flex-direction: column;
                padding: 10px 0;

                .live-btn--info {
                  max-width: 100%;
                  margin-bottom: 8px;

                  .info-time {
                    height: 40px;

                    .date {
                      font-size: 18px;
                    }
                  }
                }

                .live-info--cont {
                  flex-direction: column;

                  .info-img {
                    width: 100%;
                    height: 180px;

                    .image {
                      display: block;
                      object-fit: cover;
                    }
                  }

                  .info-text {
                    max-width: 100%;
                    height: auto;
                    padding-left: 0;
                    padding-top: 10px;

                    .title {
                      font-size: 15px;
                    }

                    .btn {
                      margin-top: 10px;

                      button {
                        width: 80px;
                        font-size: 12px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .live-calendar {
    .panel {
      .panel-head {
        padding: 15px 20px;

        .panel-title {
          font-size: 20px;
          line-height: 30px;
        }
      }

      .panel-body {
        display: block;
        padding: 15px 15px 0;

        .calendar-wrap {
          width: 100%;
          max-width: 100%;
          border-right: none;
          border-bottom: 1px solid #eee;
          margin-bottom: 20px;
          padding-bottom: 20px;
        }

        .live-info {
          width: 100%;
          margin-left: 0;

          .live-info--item {
            .live-info--cont {
              .info-img {
                width: 220px;
                height: 120px;
              }

              .info-text {
                .title {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .live-calendar {

    // margin: 0 auto 30px;
    .panel {
      .panel-body {
        .calendar-wrap {
          width: 580px;
          max-width: 580px;
        }
      }
    }
  }
}
</style>